<template>
  <div class="calendar-wrapper">
    <Calendar v-model="datesRange"
              class="calendar calendar-bottom"
              @date-select="changeDatesRange"
              @input="changeDatesRange"
              @clear-click="clearDates"
              :disabled="disabled"
              selectionMode="range"
              :dateFormat="settings.dateFormat"
              :showIcon="true"
              :monthNavigator="true"
              :yearNavigator="true"
              :showButtonBar="shouldShowButtonBar"
              :selectOtherMonths="true"
              :minDate="minDate"
              :maxDate="maxDate"
              autocomplete="off"/>
  </div>
</template>

<script>
import settings from "@/settings";
import generateMixins from "@/mixins/generateMixins";
import calculateMixins from "@/mixins/calculateMixins";
export default {
  emits: ['change-dates-range'],
  mixins: [ generateMixins, calculateMixins ],
  name: 'DatesRangeCalendar',
  props: {
    isEmptyByDefault: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: [Date,String,Boolean],
      default: null
    },
    maxDate: {
      type: Date,
      default: () => new Date()
    },
    maxRangeDays: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      datesRange: null,
      fromTimestamp: null,
      toTimestamp: null,
      settings
    }
  },
  mounted() {
    if (!this.isEmptyByDefault) {
      this.generateThisMonthRange()
    }
  },
  methods: {
    // clearDates() {
    //   this.datesRange = null
    //   this.fromTimestamp = null
    //   this.toTimestamp = null
    // },
    clearDates() {
      this.datesRange = null
      this.fromTimestamp = null
      this.toTimestamp = null

      this.$emit('change-dates-range', {
        fromTimestamp: null,
        toTimestamp: null,
      }, true)
    },
    generateThisMonthRange() {
      let now = new Date()
      let firstDayOfCurrMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 1)

      const calculatedFirstDayOfCurrMonth =  firstDayOfCurrMonth ? this.calculateDayStartDate(firstDayOfCurrMonth) : null
      const toDate = this.calculateDayEndDate(now)


      this.datesRange = [calculatedFirstDayOfCurrMonth, toDate]
      this.fromTimestamp = calculatedFirstDayOfCurrMonth ? +calculatedFirstDayOfCurrMonth / 1000 : null
      this.toTimestamp = toDate ? +toDate / 1000 : null
    },
    changeDatesRange() {
      const fromDate = this.datesRange?.[0] ?? null
      let toDate = this.datesRange?.[1] ?? null

      if (this.maxRangeDays && fromDate && toDate) {
        const maxToDate = new Date(fromDate)
        maxToDate.setDate(maxToDate.getDate() + this.maxRangeDays - 1)

        if (toDate > maxToDate) {
          toDate = maxToDate
          this.datesRange = [fromDate, toDate]
        }
      }

      const calculatedFromDate = fromDate ? this.calculateDayStartDate(fromDate) : null
      const calculatedToDate = toDate ? this.calculateDayEndDate(toDate) : null

      this.fromTimestamp = calculatedFromDate ? +calculatedFromDate / 1000 : null
      this.toTimestamp = calculatedToDate ? +calculatedToDate / 1000 : null

      if (
          (this.fromTimestamp && this.toTimestamp) ||
          (!this.fromTimestamp && !this.toTimestamp)
      ) {
        this.$emit('change-dates-range', {
          fromTimestamp: this.fromTimestamp,
          toTimestamp: this.toTimestamp
        }, true)
      }
    },
    getDateOnly(date) {
      const result = new Date(date)
      result.setHours(0, 0, 0, 0)

      return result
    },

    getMaxToDate(fromDate) {
      const maxToDate = this.getDateOnly(fromDate)
      maxToDate.setDate(maxToDate.getDate() + this.maxRangeDays - 1)

      return maxToDate
    },
  },
  computed: {
    shouldShowButtonBar() {
      if (!this.maxRangeDays) {
        return true
      }

      const fromDate = this.datesRange?.[0] ?? null
      const toDate = this.datesRange?.[1] ?? null

      if (!fromDate) {
        return true
      }

      if (toDate) {
        return true
      }

      const today = this.getDateOnly(new Date())
      const maxToDate = this.getDateOnly(this.getMaxToDate(fromDate))

      return today <= maxToDate
    },
  }
}
</script>

<style lang="scss" scoped>
.calendar-wrapper {
  .calendar {
    width: 215px;
  }
}
</style>